import { useState } from 'react';
import { PackageCheckIcon } from 'lucide-react';
import { toast } from 'sonner';
import { setOrderStatus } from '../adminApi';
import { Panel } from '../ui/Panel';
import { Spinner } from '../../ui/Spinner';
import { btnPrimary } from '../ui/styles';
import { ShipForm } from '../inbox/ShipForm';
import { errorMessage } from '../../core/errors';
import type { AdminOrder } from '../../core/types/adminRequests';
import type { Tracking } from '../../core/types/account';
type Props = {
  order: AdminOrder;
  onChanged: () => void;
};

/**
 * Inpakken en verzenden vanuit de bestelling zelf (BEHEER-PLAN §11, fase 4), met dezelfde stappen
 * en hetzelfde verzoek als de Inbox: nieuw → ingepakt → verzonden (met of zonder track & trace).
 * Alleen bij een betaalde, niet-geannuleerde bestelling die nog niet verzonden is.
 */
export function FulfilmentPanel({
  order: o,
  onChanged
}: Props) {
  const [busy, setBusy] = useState(false);
  if (o.paymentStatus !== 'betaald' || o.cancelledAt || o.fulfilment !== 'nieuw' && o.fulfilment !== 'ingepakt') return null;
  const advance = async (next: 'ingepakt' | 'verzonden', tracking?: Tracking) => {
    if (busy) return;
    setBusy(true);
    try {
      await setOrderStatus(o.id, next, tracking);
      toast.success(next === 'ingepakt' ? 'Ingepakt' : 'Verzonden', {
        description: next === 'verzonden' ? 'De klant krijgt een mail dat het pakket onderweg is.' : undefined
      });
      onChanged();
    } catch (err) {
      toast.error('Dat lukte niet', {
        description: errorMessage(err)
      });
      onChanged();
    } finally {
      setBusy(false);
    }
  };
  return <Panel title={o.fulfilment === 'nieuw' ? 'Inpakken' : 'Verzenden'} description={o.fulfilment === 'nieuw' ? 'Print de pakbon bovenaan, pak in, en zet hem hier op ingepakt.' : 'Ingepakt. Zet hem op verzonden zodra hij de deur uit is.'} data-id="element-3488" data-mp="1ny4hrhbkofxd">
      {o.fulfilment === 'nieuw' ? <button type="button" disabled={busy} onClick={() => void advance('ingepakt')} className={btnPrimary} data-id="element-3489" data-mp="7knzrn2dneo5">
          {busy ? <Spinner data-id="element-3490" data-mp="93e7sn8ssm2k" /> : <PackageCheckIcon className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" data-id="element-3491" data-mp="92w4x7rmr9lo" />}
          Ingepakt
        </button> : <fieldset disabled={busy} className="max-w-md" data-id="element-3492" data-mp="1okntly89al">
          <legend className="sr-only" data-id="element-3493" data-mp="vd4qf61fre">Verzenden</legend>
          <ShipForm orderId={o.id} onShip={t => void advance('verzonden', t)} data-id="element-3494" data-mp="42gsqjj3485a" />
        </fieldset>}
    </Panel>;
}